import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.containers.Checklist.ExternalArea.title',
    defaultMessage: 'Área externa',
  },
  finishButton: {
    id: 'app.containers.Checklist.ExternalArea.finishButton',
    defaultMessage: 'Salvar itens da área externa',
  },
  invalid: {
    id: 'app.containers.Checklist.ExternalArea.invalid',
    defaultMessage: 'Preencha todos os itens',
  },
});
